import React, { ComponentProps } from 'react';
import styled from 'styled-components';

import { commonLinkStyle } from './common.style';
import UnstyledLink from './UnstyledLink';

const LinkEl = styled(UnstyledLink)`
  ${commonLinkStyle}
`;

const ClickTargetWrapper = styled.div`
  display: contents;
`;

type ClickableTargetProps = {
  onClick: () => void;
};

type PropsLink = Omit<ComponentProps<typeof UnstyledLink>, 'href'> &
  ClickableTargetProps;

function LinkClickable({
  onClick,
  children,
  color = 'light',
  ...rest
}: PropsLink) {
  return (
    <ClickTargetWrapper
      onClick={event => {
        event.preventDefault();
        if (rest.disabled !== true) {
          onClick();
        }
      }}
    >
      <LinkEl color={color} href="#" {...rest}>
        {children}
      </LinkEl>
    </ClickTargetWrapper>
  );
}

export default LinkClickable;
